(() => {
  if (customElements.get('slider-reviews')) {
    return;
  }

  class SliderReviews extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 42,
        pagination: {
          el: "[data-pagination]"
        },
        breakpoints: {
          480: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 82
          }
        }
      });
    }
  }

  customElements.define('slider-reviews', SliderReviews);
})();
